import i18next from 'i18next';
import i18n from '../../i18n';
import getExtensionI18nextNamespace from './get-extension-i18next-namespace';
import fetchExtensionAsset from './fetch-extension-asset';

const loadExtensionTranslations = (extension, locale) => {
  const namespace = getExtensionI18nextNamespace(extension.slug);
  let extensionLocale = i18n.constants.DEFAULT_LOCALE;
  if (extension.translations.includes(locale)) {
    extensionLocale = locale;
  }
  if (i18next.hasResourceBundle(extensionLocale, namespace)) {
    return Promise.resolve();
  }

  return fetchExtensionAsset(extension.slug, `/locale/${extensionLocale}.json`)
    .then(({ data }) => i18next.addResourceBundle(extensionLocale, namespace, data, true, true))
    .catch(() => {
      fetchExtensionAsset(extension.slug, `/locale/${i18n.constants.DEFAULT_LOCALE}.json`).then(
        ({ data }) =>
          i18next.addResourceBundle(i18n.constants.DEFAULT_LOCALE, namespace, data, true, true)
      );
    });
};

export default loadExtensionTranslations;
